module.exports = __webpack_public_path__ + "img/54_3.3d94063c.png";